"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function check() {
    var elem = document.createElement("canvas");
    if (!!(elem.getContext && elem.getContext("2d"))) {
        return elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
    }
    else {
        return false;
    }
}
var isSupportWebP = (function () {
    var result;
    return function () {
        if (result === undefined) {
            result = check();
        }
        return result;
    };
})();
exports.default = isSupportWebP;
